// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".products-listing-results-count[data-v-5206603a]{font-family:\"MotivaSans Light\";font-size:1.4rem}.products-listing-results-count__number[data-v-5206603a]{font-family:\"MotivaSans SemiBold\"}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
